import { AddOutlined, RemoveOutlined } from "@mui/icons-material";
import { Box, Button, IconButton } from "@mui/material";
import { setMobileButttonBackColor, setMobileTextColor } from "../../utility";
import { t } from "i18next";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";

const OrderButton = ({
  item,
  selected,
  width,
  setFieldValue,
  values,
  isSuccess,
  resetForm,
  checked,
  handleQuantityChange,
  formQty,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [qty, setQty] = useState(parseInt(formQty));

  useEffect(() => {
    setQty(parseInt(formQty));
  }, [formQty]);

  useEffect(() => {
    if (checked && isSuccess) {
      resetForm();
    }
  }, [isSuccess]);

  const handleQty = (type) => {
    if (type === "+") {
      setQty(qty + 1);
      handleQuantityChange(qty + 1);
      setFieldValue("quantity", qty + 1);
    } else if (type === "-") {
      handleQuantityChange(qty - 1);
      setFieldValue("quantity", qty - 1);
      setQty(qty - 1);
    }
  };

  return (
    <div
      className="rounded-2 order-button text-center alignByLang"
      style={{
        width: "100%",
        marginRight: fullScreen ? "" : "8px",
      }}
    >
      <div className="order-button-content d-flex justify-content-between p-2">
        <div style={{ width: "100%" }} className="mx-2">
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            style={{
              backgroundColor: setMobileButttonBackColor(),
              padding: "8px",
              borderRadius: "8px",
            }}
          >
            <IconButton
              onClick={() => handleQty("-")}
              size="small"
              style={{
                backgroundColor: setMobileButttonBackColor(),
                color: setMobileTextColor(),
              }}
              disabled={qty <= 1} // Disable if quantity <= 1
            >
              <RemoveOutlined />
            </IconButton>

            <span
              style={{
                margin: "0 8px",
                color: setMobileTextColor(),
              }}
            >
              |
            </span>

            <Button
              className="rounded-2 sub-font"
              style={{
                backgroundColor: setMobileButttonBackColor(),
                color: setMobileTextColor(),
                fontSize: "16px",
                fontWeight: 600,
                width: "100%",
                border: "none",
              }}
              type="submit"
            >
              {t("Add to cart")}
            </Button>

            <span
              style={{
                margin: "0 8px",
                color: setMobileTextColor(),
              }}
            >
              |
            </span>

            <IconButton
              onClick={() => handleQty("+")}
              size="small"
              style={{
                backgroundColor: setMobileButttonBackColor(),
                color: setMobileTextColor(),
              }}
            >
              <AddOutlined />
            </IconButton>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default OrderButton;
